'use client';

import { NavBarContainer } from './navBarContainer';
import { Menu } from './menu';
import { OpenMenuButton } from './openMenuButton';
import { Nav } from './Nav';
import { LogoLink } from './logoLink';
import { NavigationProvider } from './NavigationContext';

interface PrimaryNavigationClientProps {
  isHeroImagePage: boolean;
  isFixed?: boolean;
}

export function PrimaryNavigationClient({
  isHeroImagePage,
  isFixed = true,
}: PrimaryNavigationClientProps) {
  return (
    <NavigationProvider>
      <Nav isSlate={isHeroImagePage} isFixed={isFixed}>
        <NavBarContainer>
          <LogoLink />
          <Menu />
          <OpenMenuButton />
        </NavBarContainer>
      </Nav>
    </NavigationProvider>
  );
}
